import { render, staticRenderFns } from "./SendInvitation.vue?vue&type=template&id=34e0704b&"
import script from "./SendInvitation.vue?vue&type=script&lang=js&"
export * from "./SendInvitation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports